'use strict';

var App = require('app');
var AppState = require('app_state');
var Controller = require('components/account/account_controller');

var LoginComponent = {};

LoginComponent.initializeRouting = function () {
    new LoginComponent.Router({
        controller: API,
    });
};

if (AppState.isSubdomain) {
    LoginComponent.Router = App.BaseRouter.extend({
        appRoutes: {
            login: 'showLogin',
            'password-reset': 'showPasswordReset',
            signup: 'showSignup', // invitations only
        },
    });
} else {
    LoginComponent.Router = App.BaseRouter.extend({
        appRoutes: {
            login: 'showLogin',
            'password-reset': 'showPasswordReset',
            signup: 'showSignup', // invitations only
            //'signup-company': 'showSignupCompany' -> TODO: re-activate
        },
    });
}

var API = {
    showLogin: function (contextData) {
        Controller.showLogin(contextData);
    },
    showPasswordReset: function () {
        Controller.showPasswordReset();
    },
    showSignup: function (refParams) {
        Controller.showSignup(refParams);
    },
    showSignupCompany: function () {
        Controller.showSignupCompany();
    },
};

App.on('login:show', function (contextData) {
    if (
        !AppState.lastLocation &&
        Backbone.history.getFragment() != '' &&
        Backbone.history.getFragment().substring(0, 8) != 'activate' &&
        Backbone.history.getFragment() != 'login'
    ) {
        AppState.lastLocation = window.location.href;
    }
    App.navigate('login');
    API.showLogin(contextData);
});

App.on('password-reset:show', function () {
    App.navigate('password-reset');
    API.showPasswordReset();
});

App.on('signup:show', function (refParams) {
    App.navigate('signup');
    API.showSignup(refParams);
});

module.exports = LoginComponent;
